import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { PropType, reactive, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';

import { SdsProduct, SdsSection9 } from '@/interfaces/model/general/sds';
import { NewSdsSection9 } from '@/lib/constructor/model/general/sds';
import SdsSection9Form from '@/views/dashboard/sdsDrawer/forms/SdsSection9Form.vue';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection9',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  section9: {
    type: Array as PropType<Array<SdsSection9>>,
    required: true,
    default: () => [],
  },
  productIndex: {
    type: Number,
    default: 0,
  },
  products: {
    type: Array as PropType<Array<SdsProduct>>,
    default: () => [],
  },
},
  emits: ["update:isValid", "update:section9"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:section9', data: Array<SdsSection9>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  physicalChemicalProperties: '{name}の物理的及び化学的性質',
  enterNewData: '追加する第9章のデータを入力してください',
  condition: '外観',
  physicalCondition: '物理的状態',
  form: '形状・性状',
});



const headerSection9 = [
  { text: $t(m.condition), value: 'condition', sortable: false },
  {
    text: $t(m.physicalCondition),
    value: 'physicalCondition',
    sortable: false,
  },
  { text: $t(m.form), value: 'form', sortable: false },
  { text: '', value: 'action', sortable: false },
];

const isValidUpdatedSection9 = ref<boolean>(false);
const isValidNewSection9 = ref<boolean>(false);
const expanded = ref<Array<number>>([0]);

const newSection9 = reactive<SdsSection9>(structuredClone(NewSdsSection9));
const updatedSection9 = reactive<SdsSection9>(structuredClone(NewSdsSection9));

const section9Index = ref<number>(0);

const modalAddSection9 = ref<boolean>(false);
const modalDeleteSection9 = ref<boolean>(false);
const modalRescueSection9 = ref<boolean>(false);
const modalEditSection9 = ref<boolean>(false);

const openAddSection9Modal = (): void => {
  modalAddSection9.value = true;
};

const closeAddSection9Modal = (): void => {
  modalAddSection9.value = false;
};

const openDeleteSection9Modal = (): void => {
  modalDeleteSection9.value = true;
};

const closeDeleteSection9Modal = (): void => {
  modalDeleteSection9.value = false;
};

const openRescueSection9Modal = (): void => {
  modalRescueSection9.value = true;
};

const closeRescueSection9Modal = (): void => {
  modalRescueSection9.value = false;
};

const openEditSection9Modal = (): void => {
  modalEditSection9.value = true;
};

const closeEditSection9Modal = (): void => {
  modalEditSection9.value = false;
};



const bindSection9 = () => {
  updatedSection9.id = props.section9[section9Index.value].id;
  updatedSection9.sds_id = props.section9[section9Index.value].sds_id;
  updatedSection9.condition = props.section9[section9Index.value].condition;
  updatedSection9.physical_condition =
    props.section9[section9Index.value].physical_condition;
  updatedSection9.form = props.section9[section9Index.value].form;
  updatedSection9.created_at = props.section9[section9Index.value].created_at;
  updatedSection9.updated_at = props.section9[section9Index.value].updated_at;
  updatedSection9.deleted_at = props.section9[section9Index.value].deleted_at;
};

const clearNewSection9Form = () => {
  newSection9.id = 0;
  newSection9.sds_product_id = 0;
  newSection9.sds_id = '';
  newSection9.condition = '';
  newSection9.physical_condition = '';
  newSection9.form = '';
  newSection9.deleted_at = null;
};

const addSection9 = () => {
  const data: Array<SdsSection9> = [...props.section9];
  data.push(structuredClone(newSection9));

  emits('update:section9', data);
};

const editSection9 = () => {
  const data: Array<SdsSection9> = [...props.section9];
  data[section9Index.value].condition = updatedSection9.condition;
  data[section9Index.value].physical_condition =
    updatedSection9.physical_condition;
  data[section9Index.value].form = updatedSection9.form;

  emits('update:section9', data);
};

const deleteSection9 = (): void => {
  const data = props.section9;
  data[section9Index.value].deleted_at = now().toString();

  emits('update:section9', data);
};

const rescueSection9 = (): void => {
  const data = props.section9;
  data[section9Index.value].deleted_at = null;

  emits('update:section9', data);
};

return { __sfc: true,$t, m, props, headerSection9, isValidUpdatedSection9, isValidNewSection9, expanded, newSection9, updatedSection9, section9Index, modalAddSection9, modalDeleteSection9, modalRescueSection9, modalEditSection9, openAddSection9Modal, closeAddSection9Modal, openDeleteSection9Modal, closeDeleteSection9Modal, openRescueSection9Modal, closeRescueSection9Modal, openEditSection9Modal, closeEditSection9Modal, emits, bindSection9, clearNewSection9Form, addSection9, editSection9, deleteSection9, rescueSection9, SdsSection9Form, sharedMessages }
}

})